exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".subTotalSummary-priceSummary {\n  padding: 0.5rem 0rem; }\n\n.subTotalSummary-totalPriceText {\n  font-family: 'Lato-Bold', sans-serif;\n  font-weight: bold;\n  color: var(--text); }\n\n.subTotalSummary-priceItem {\n  display: flex;\n  justify-content: space-between;\n  padding: 0.5rem 0rem;\n  color: var(--text); }\n", ""]);

// exports
